function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.806,6.845,18.7,2.218a.664.664,0,1,0-.919.959l4.9,4.432V21.333a.664.664,0,1,0,1.328,0V7.325A.665.665,0,0,0,23.806,6.845Z",
  transform: "translate(-0.01 -1.997)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M14.337,2.183a.665.665,0,1,0-.924.955l6.318,5.848V21.333a.664.664,0,1,0,1.328,0V8.7a.663.663,0,0,0-.2-.477Z",
  transform: "translate(-0.01 -1.997)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M10.377,2.51a1.42,1.42,0,0,0-.13-.12h-.01c0-.01-.01-.01-.01-.02-.03-.01-.05-.04-.07-.06s-.03-.01-.05-.02a1.5,1.5,0,0,0-.38-.19c-.03-.01-.06-.02-.1-.03a2.076,2.076,0,0,0-.5-.06,1.731,1.731,0,0,0-1.02.3c-.03.02-.05.05-.07.06-.05.05-.1.09-.15.14L.44,9.125a1.311,1.311,0,0,0-.43.889V20.3a.09.09,0,0,0,.01.05,1.615,1.615,0,0,0,1.55,1.629H16.43a1.623,1.623,0,0,0,1.56-1.629V10.014a1.32,1.32,0,0,0-.42-.889ZM11.87,20.386a.267.267,0,0,1-.27.26H6.4a.258.258,0,0,1-.26-.26V15.18a.258.258,0,0,1,.26-.26h5.2a.267.267,0,0,1,.27.26Zm4.8-.16a.248.248,0,0,0-.01.08.317.317,0,0,1-.23.34H13.18a2.109,2.109,0,0,0,.02-.26V15.18a1.6,1.6,0,0,0-1.6-1.589H6.4A1.587,1.587,0,0,0,4.81,15.18v5.206a2.108,2.108,0,0,0,.02.26H1.57c-.09,0-.22-.13-.23-.36V10.1l7.407-6.6a.345.345,0,0,0,.09-.08.01.01,0,0,0,.01-.01l.04-.02c0-.01.01-.02.02-.03a.881.881,0,0,1,.22-.03.415.415,0,0,1,.16.02c.01,0,.06.02.07.02l.03.03c.01,0,.01.01.02.01l.03.03.02.02,7.193,6.615c.01.01.01.02.02.02Z",
  transform: "translate(-0.01 -1.997)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/estates.e3b12760.svg";
export { SvgComponent as ReactComponent };